export const actionTypes = {
  GET_SUBSCRIPTION_PRODUCT_REQUEST: 'GET_SUBSCRIPTION_REQUEST',
  GET_SUBSCRIPTION_PRODUCT_SUCCESS: 'GET_SUBSCRIPTION_SUCCESS',
  GET_SUBSCRIPTION_PRODUCT_FAILURE: 'GET_SUBSCRIPTION_AIULURE',
};
